export const formatPhoneNumber = (val, setter) => {
    let ph = val
        .replace('(', '')
        .replace(')', '')
        .replace('-', '')
        .replace(' ', '');
    if (ph.length < 10) {
        setter(ph);
    } else {
        setter(`(${ph.slice(0, 3)}) ${ph.slice(3, 6)}-${ph.slice(6, 10)}`);
    }
};